import { TooltipsResolveAction, TooltipsResolveActionType } from "../TooltipsResolveActions";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";

export function switchOnErrorsLogTooltipUseHighlanderPath(
    highlanderPath: string,
    errorId: string,
    attachmentId: string
): CandyThunkAction<Promise<void>> {
    return async (dispatch, _, form) => {
        const attachmentPublicForm = form.getAttachmentsPublicFormsById(attachmentId);
        const bindingPath: string = await attachmentPublicForm
            .getNavigationPathMapper()
            .mapPathWithLazyLoading(highlanderPath);

        if (bindingPath) {
            dispatch(switchOnErrorsLogTooltipAttachment([bindingPath], errorId, attachmentId, highlanderPath));
        }
    };
}

export function switchOnErrorsLogTooltipAttachment(
    bindingPath: string[],
    errorId: string,
    attachmentId?: string,
    highlanderPath?: string
): TooltipsResolveAction {
    return {
        type: TooltipsResolveActionType.DisableOwnTooltipAttachment,
        payload: {
            bindingPaths: bindingPath,
            errorId: errorId,
            attachmentId: attachmentId,
            highlanderPath: highlanderPath,
        },
    };
}

export function switchOffErrorsLogTooltipAttachment(): TooltipsResolveAction {
    return {
        type: TooltipsResolveActionType.EnableOwnTooltipAttachment,
    };
}

export function switchOnErrorsLogTooltip(bindingPath: string[], errorId: string): TooltipsResolveAction {
    return {
        type: TooltipsResolveActionType.DisableOwnTooltip,
        payload: {
            bindingPaths: bindingPath,
            errorId: errorId,
        },
    };
}

export function switchOffErrorsLogTooltip(): TooltipsResolveAction {
    return {
        type: TooltipsResolveActionType.EnableOwnTooltip,
    };
}
